import { useMemo } from 'react';
import { CAR_FLOW_TYPE } from '~/data/car/carCardData';
import { ROUTES } from '~/data/routes';
import { UsedCarType } from '~/data/types/usedCar/usedCarData';
import { EUrlParam } from '~/data/urlParams';
import { useCurrentUrlParams } from '~/hooks/useCurrentUrlParams';

export const useUsedCarPageUrl = (
  car: UsedCarType,
  dealType: CAR_FLOW_TYPE,
) => {
  const currentUrlParams = useCurrentUrlParams({ cleanAppParams: true });
  currentUrlParams.set(EUrlParam.DEAL_TYPE, dealType);

  const paramsString = currentUrlParams.toString();

  const queryParams = paramsString ? `?${paramsString}` : '';

  return useMemo(() => {
    const makeName =
      car?.usedCarSpec?.makeNameEn?.toLocaleLowerCase() ||
      car?.carZoneManufacturerNameEn?.toLocaleLowerCase() ||
      car?.carZoneManufacturerName?.toLocaleLowerCase() ||
      'unknown';

    const modelName =
      car?.usedCarSpec?.seriesNameEn
        ?.replace(/\s+/g, '-')
        .toLocaleLowerCase() ||
      car?.usedCarSpec?.modelNameEn?.replace(/\s+/g, '-').toLocaleLowerCase() ||
      car?.carZoneModelName?.replace(/\s+/g, '-').toLocaleLowerCase() ||
      'unknown';
    const year = car.year || 'unknown';
    const carId = car.id || 'unknown';

    return `${ROUTES.USED_CAR}/${makeName}/${modelName}/${year}-c${carId}${queryParams}`;
  }, [car, queryParams]);
};
